var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"wiki container",attrs:{"id":"wiki"}},[_c('article',{attrs:{"id":"article"}},[_c('router-view')],1),_c('aside',[_c('h1',[_vm._v("Wiki")]),_c('sidebar')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }